interface QuizIntroProps {
  onStart: () => void;
}

export default function QuizIntro({ onStart }: QuizIntroProps) {
  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
      <div className="text-center mb-8">
        {/* Logo Don Bandi */}
        <div className="flex justify-center mb-6">
          <img
            src="https://static.readdy.ai/image/1641cce445e23a33732a9af05560332a/70e0a6262e82dd81bec3e04351468183.png"
            alt="Don Bandi - Aula K9 El Taller de Pensar"
            className="h-24 w-auto object-contain"
          />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          ¿Qué perro es perfecto para ti?
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Descubre qué raza de perro se adapta mejor a tu estilo de vida con nuestro test interactivo. 
          Responde 12 preguntas y obtén recomendaciones personalizadas.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-10">
        <div className="text-center p-6 bg-gray-50 rounded-xl">
          <div className="w-12 h-12 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-3">
            <i className="ri-time-line text-secondary-600 text-2xl"></i>
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">5 minutos</h3>
          <p className="text-sm text-gray-600">Tiempo estimado</p>
        </div>

        <div className="text-center p-6 bg-gray-50 rounded-xl">
          <div className="w-12 h-12 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-3">
            <i className="ri-question-line text-secondary-600 text-2xl"></i>
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">12 preguntas</h3>
          <p className="text-sm text-gray-600">Rápido y sencillo</p>
        </div>

        <div className="text-center p-6 bg-gray-50 rounded-xl">
          <div className="w-12 h-12 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-3">
            <i className="ri-shield-check-line text-secondary-600 text-2xl"></i>
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">Personalizado</h3>
          <p className="text-sm text-gray-600">Resultado adaptado a ti</p>
        </div>
      </div>

      <div className="flex justify-center">
        <button
          onClick={onStart}
          className="inline-flex items-center justify-center rounded-full bg-accent-500 px-10 py-4 text-lg font-semibold text-white shadow-lg hover:bg-accent-600 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          Empezar Test
          <i className="ri-arrow-right-line ml-2 text-xl"></i>
        </button>
      </div>

      <div className="mt-8 text-center text-sm text-gray-500">
        <p>✨ Test desarrollado por profesionales de AULA K9 - Don Bandi</p>
      </div>
    </div>
  );
}
